import actionTypes from '../constants/action-types';

const fetchAvailablePackagesComplete = () => ({
  type: actionTypes.FETCH_AVAILABLE_PACKAGES_COMPLETE,
});

export default fetchAvailablePackagesComplete;
